import React from 'react';
import { setShowFitAssistant, setStepEnum } from '../../Slices/FitAssistantSlice.ts';
import { ButtonHelper } from '../../Helpers/ButtonHelper.ts';
import { useAppSelector, useAppDispatch } from '../../Store/store.ts';
import {
  FitStatusSelector,
  HasAddedRooftopTentsRoofRackSelector,
  InitialDataSelector,
  CurrentStepSelector,
  TranslationsSelector,
} from '../../Selectors/FitAssistantSelectors.ts';
import FitAssistantStatus from '../../Enums/FitAssistantStatus.ts';
import { resetFitAssistant } from '../../Thunks/Reset.ts';
import FitAssistantStep from '../../Enums/FitAssistantStep.ts';
import { CarInformationSelector } from '../../Selectors/FitAssistantSelectors.ts';
import { trackFindRoofRack, trackOpenEmpty } from '../../Analytics/Adobe.ts';

import './RoofTopTentButton.less';

export default function RoofTopTentButton() {
  const dispatch = useAppDispatch();
  const fitStatus = useAppSelector(FitStatusSelector);
  const initialData = useAppSelector(InitialDataSelector);
  const translations = useAppSelector(TranslationsSelector);
  const carInformation = useAppSelector(CarInformationSelector);
  const hasAddedRooftopTentsRoofRack = useAppSelector(HasAddedRooftopTentsRoofRackSelector);
  const currentStep = useAppSelector(CurrentStepSelector);

  const handleOpenFitAssistant = async (): Promise<void> => {
    await dispatch(resetFitAssistant(true));
    trackOpenEmpty(initialData.FitAssistantVariation, initialData.IsYearFirst, [], initialData.Steps[0].Parameter);
    dispatch(setShowFitAssistant(true));
  };

  const handleFindRoofRack = (): void => {
    dispatch(setStepEnum(FitAssistantStep.RoofRacks));
    dispatch(setShowFitAssistant(true));
    trackFindRoofRack(
      initialData.FitAssistantVariation,
      initialData.IsYearFirst,
      FitAssistantStep.RoofRacks,
      carInformation
    );
  };

  return (
    <div className="roof-top-tent-button">
      <div className="d-flex mb-3 roof-top-tent-button__header">
        <i
          className={`fit-indicator ${fitStatus} ${ButtonHelper.getIconClassByFitAssistantStatus(fitStatus, initialData?.FitAssistantVariation)}`}
        ></i>
        {fitStatus === FitAssistantStatus.NoSelection && <span>{translations.cheackFitHeader}</span>}
        {(fitStatus === FitAssistantStatus.Confirmed ||
          fitStatus === FitAssistantStatus.ConfirmedNoRacks ||
          fitStatus === FitAssistantStatus.NoFit) && (
          <span>{ButtonHelper.GetCarInformationBtnText(carInformation)}</span>
        )}
      </div>
      <div className="d-flex mb-6">
        <p className="mb-0 paragraph--s">
          {fitStatus === FitAssistantStatus.NoSelection && (
            <span dangerouslySetInnerHTML={{ __html: translations.noSelectionText }} />
          )}
          {fitStatus === FitAssistantStatus.Confirmed && !hasAddedRooftopTentsRoofRack && (
            <span dangerouslySetInnerHTML={{ __html: translations.confirmedText }} />
          )}
          {fitStatus === FitAssistantStatus.Confirmed && hasAddedRooftopTentsRoofRack && (
            <span dangerouslySetInnerHTML={{ __html: translations.addedRoofRackToCart }} />
          )}
          {fitStatus === FitAssistantStatus.ConfirmedNoRacks && (
            <span dangerouslySetInnerHTML={{ __html: translations.confirmedNoRacksText }} />
          )}
          {fitStatus === FitAssistantStatus.NoFit && (
            <span dangerouslySetInnerHTML={{ __html: translations.noFitText }} />
          )}
        </p>
      </div>
      <div className="d-flex justify-content-center align-items-center buttons">
        {fitStatus === FitAssistantStatus.Confirmed && !hasAddedRooftopTentsRoofRack && (
          <button className="btn btn-sm thule-btn-secondary" onClick={handleFindRoofRack}>
            {translations.findRoofRackButtonText}
          </button>
        )}
        <button className="btn btn-sm thule-btn-secondary" onClick={handleOpenFitAssistant}>
          {fitStatus === FitAssistantStatus.NoSelection
            ? translations.checkFitButtonText
            : translations.changeCarButtonText}
        </button>
      </div>
    </div>
  );
}
